import styled from 'styled-components';

export const SidebarMenuContainer = styled.ul`
  display: flex;
  flex-direction: column;
`;

export const SidebarMenuNavIndicator = styled.div`
  position: absolute;
  transition: top 200ms;
  height: 20px;
  width: 4px;
  left: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  background-color: ${({ theme }) => theme.green[500]};
`;
